import axios from 'axios';
import Common from '../../componets/Common';

const initialData = {
  transaccionId: "",
  urlPowerpay: "",
  mensajeError: ""
};

export const generarTransaccionPowerpay = async (idOrden, studentCode, config) => {
  const url = `${Common.urlAPI}/GenerarTransaccionPowerpay/${idOrden}/${studentCode}`;  

  try {
    const resp = await axios.get( url, config );
    if (resp.data.state === "OK") {
      return {
        ...initialData,
        transaccionId: resp.data.transaccionId,
        urlPowerpay: resp.data.urlPowerpay,
      }
    }

    return {
      ...initialData,
      mensajeError: resp.data.message
    }
  } catch (err) {
    console.log('error',err);
    const mensajeError = err.response && err.response.status === 401 ? "El token es invalido para este usuario" : err.toString();
    
    return {
      ...initialData,
      mensajeError
    }
  }
}
